import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {

  // 检查用语部门列表
  checkDeptList() {
    return Axios({
      url: requestPrefix.projectUrl + '/speechDept/speechDeptList',
      method: 'get'
    })
  },
  // 检查项目列表
  checkItemList(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/jsiCategory/list',
      method: 'get',
      params
    })
  },
  // 检查部位列表
  checkAreaList(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/jsiObject/list',
      method: 'post',
      data: params
    })
  },
  // 检查部位列表
  checkInspectionList(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/jsiStandard/list',
      method: 'post',
      data: params
    })
  },
  pageListSpeech(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/speechInspection/pageInspection',
      method: 'get',
      params
    })
  }

}



// WEBPACK FOOTER //
// ./src/api/speech/index.js